import {
  Button,
  CloseIcon,
  FlexBox,
  JoonUIColor,
  SPACING,
  TextButton,
  TherapistIcon,
  Typography,
} from "@joonapp/web-shared"
import { useEffect, useState } from "react"
import { Trans, useTranslation } from "react-i18next"

import { useTherapistsQuery } from "../../../networking/queries"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../../util/analytics"
import { localStorageItems } from "../../../util/storage"
import { useLinkTherapistModalStore } from "../../care/therapists/useLinkTherapistModalStore"

const InviteABASection = () => {
  const { t } = useTranslation()
  const { onOpen: openLinkTherapistModal } = useLinkTherapistModalStore()
  const { data: therapists, isLoading: isLoadingTherapists } =
    useTherapistsQuery()
  const [forceUpdate, setForceUpdate] = useState(false)

  const showABAInviteSection = localStorage.getItem(
    localStorageItems.showABAInviteSection
  )
  const hasLinkedTherapist = therapists && therapists?.length > 0
  const isComponentHidden =
    isLoadingTherapists || hasLinkedTherapist || !showABAInviteSection

  useEffect(() => {
    if (isComponentHidden) return
    trackAnalyticEvent(ANALYTIC_EVENTS.SHOW_ABA_THERAPIST_PROMPT)
  }, [isComponentHidden])

  if (isComponentHidden) return <></>

  const handleClose = () => {
    localStorage.removeItem(localStorageItems.showABAInviteSection)
    setForceUpdate(!forceUpdate)
    trackAnalyticEvent(ANALYTIC_EVENTS.ABA_THERAPIST_FORCE_CLOSE)
  }

  return (
    <FlexBox
      direction="column"
      gap={SPACING.space2}
      align="center"
      style={{
        background:
          "linear-gradient(108deg, rgba(255, 255, 255, 0.60) -6.4%, rgba(255, 255, 255, 0.80) 20.05%, rgba(255, 255, 255, 0.70) 69.45%, rgba(255, 255, 255, 0.60) 111.48%)",
        borderRadius: SPACING.space4,
        padding: SPACING.space4,
        position: "relative",
      }}
    >
      <TextButton
        onClick={handleClose}
        style={{
          padding: SPACING.space1,
          position: "absolute",
          top: SPACING.space2,
          right: SPACING.space2,
        }}
      >
        <CloseIcon color={JoonUIColor.icon.neutral} />
      </TextButton>
      <FlexBox
        direction="column"
        justify="center"
        align="center"
        gap={SPACING.space1}
        style={{ width: "min(450px, 100%)" }}
      >
        <TherapistIcon size={32} color={JoonUIColor.background.accent} />

        <Typography variant="bodyBold" textAlign="center">
          <Trans i18nKey="ME_ABA_TITLE" components={{ br: <br /> }} />
        </Typography>
        <Typography variant="bodySmall" textAlign="center">
          <Trans i18nKey="ME_ABA_DESC" components={{ b: <strong /> }} />
        </Typography>
        <Button
          text={t("ME_ABA_INVITE")}
          style={{ width: "min(300px, 100%)", marginTop: SPACING.space2 }}
          onClick={() => {
            trackAnalyticEvent(ANALYTIC_EVENTS.ADD_THERAPIST_PROMPT_INVITE, {
              source: "me_page",
            })
            openLinkTherapistModal(false)
          }}
        />
      </FlexBox>
    </FlexBox>
  )
}

export default InviteABASection
